export let serverUrl ="";

if(window.location.hostname === "localhost"){
//    serverUrl= "http://localhost:8080";
    serverUrl= "https://extreact.dev.tdd.rl-conseils.net/";
}

